import i18n from '../../languages/i18n';

export const getValueFromString = string => {
  // return '--';
  if (!string) return undefined;
  try {
    const obj = JSON.parse(string);
    // Ưu tiên ngôn ngữ hiện tại, fallback sang 'vi' hoặc 'en'
    return obj[i18n.language];
  } catch {
    return string || undefined;
  }
};
